(function () {
  var MIN_PX = 12;

  function fitTitle(root) {
    if (!root) return;

    var heading = root.querySelector('h1');
    if (!heading) return;

    var available = Math.floor(root.clientWidth);
    if (available <= 0) return;

    heading.style.fontSize = '';
    heading.style.whiteSpace = 'nowrap';
    heading.style.lineHeight = '1.05';

    var cssSize = parseFloat(window.getComputedStyle(heading).fontSize) || 40;
    if (heading.scrollWidth <= available) {
      heading.style.fontSize = cssSize + 'px';
      return;
    }

    var low = MIN_PX;
    var high = cssSize;
    var best = MIN_PX;

    while (high - low > 0.5) {
      var mid = (low + high) / 2;
      heading.style.fontSize = mid + 'px';

      if (heading.scrollWidth > available) {
        high = mid;
      } else {
        best = mid;
        low = mid;
      }
    }

    heading.style.fontSize = best + 'px';
  }

  function fitAll() {
    document.querySelectorAll('.product__title--fit').forEach(fitTitle);
  }

  function init() {
    var run = function () {
      fitAll();
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(run);
    } else {
      run();
    }

    window.addEventListener('resize', run);

    if (typeof ResizeObserver !== 'undefined') {
      document.querySelectorAll('.product__title--fit').forEach(function (el) {
        var observer = new ResizeObserver(run);
        observer.observe(el);
      });
    }

    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
